import { faker } from '@faker-js/faker';

import type { SignUpConfirmPostResponse } from '../types/SignUpConfirmPostResponse';

export function createSignUpConfirmPostResponse(
  data: NonNullable<Partial<SignUpConfirmPostResponse>> = {}
): NonNullable<SignUpConfirmPostResponse> {
  return {
    ...{
      data: {},
      response: {
        date: faker.string.alpha(),
        messages: faker.helpers.arrayElements([faker.string.alpha()]) as any,
        status: faker.number.int(),
        type: faker.string.alpha(),
      },
    },
    ...data,
  };
}
